var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUmbrella03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 21.9593L12 12M17 3.33971C12.6868 0.849491 7.28964 1.93758 4.246 5.6829C3.94893 6.04846 3.80039 6.23123 3.75718 6.49312C3.7228 6.70148 3.77373 6.97761 3.88018 7.15999C4.01398 7.38923 4.25111 7.52614 4.72539 7.79996L19.2746 16.2C19.7489 16.4738 19.986 16.6107 20.2514 16.6119C20.4626 16.6129 20.7272 16.519 20.8905 16.385C21.0957 16.2167 21.1797 15.9966 21.3477 15.5566C23.0695 11.0481 21.3132 5.82992 17 3.33971ZM17 3.33971C15.0868 2.23514 11.2973 5.21703 8.5359 9.99996M17 3.33971C18.9132 4.44428 18.2255 9.21703 15.4641 14M22 22H2",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella03);
export default __webpack_public_path__ + "static/media/umbrella-03.a7ccf50884088d08fb610094347a3d32.svg";
export { ForwardRef as ReactComponent };